export function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download our VPN application for your device. Installation takes just a few minutes with our user-friendly setup wizard.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Create Account',
      description: 'Sign up with your email and create a secure account. Choose your preferred subscription plan and payment method.',
      icon: 'ri-user-add-line'
    },
    {
      number: '03',
      title: 'Connect to Server',
      description: 'Select a server location from our global network and click connect. Your connection will be encrypted instantly.',
      icon: 'ri-server-line'
    },
    {
      number: '04',
      title: 'Browse Securely',
      description: 'Enjoy complete privacy and security while browsing. Your data is encrypted and your identity is protected.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-lightbulb-line text-teal-600"></i>
            <span className="text-teal-900 text-sm font-semibold">Simple Process</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get started with our VPN in four easy steps and protect your online privacy in minutes
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-teal-300 to-transparent -translate-x-1/2 z-0"></div>
              )}
              
              <div className="relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-100 hover:border-teal-300 transition-all duration-300 hover:shadow-lg">
                <div className="absolute -top-4 -left-4 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-full text-white font-bold text-lg shadow-lg">
                  {step.number}
                </div>
                
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl mb-6 shadow-md mx-auto">
                  <i className={`${step.icon} text-teal-600 text-3xl`}></i>
                </div>
                
                <h4 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  {step.title}
                </h4>
                <p className="text-gray-600 text-center leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-teal-600 to-teal-700 text-white px-10 py-4 rounded-full hover:from-teal-700 hover:to-teal-800 transition-all font-semibold text-lg shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Get Started Now
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
